var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c("div", [
        _c("div", { staticClass: "info--text text-uppercase my-3 mt-2" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.generateMessage("requests.details.titles.exploitation")
              ) +
              "\n  "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage("requests.details.titles.maintenance")
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("custom-simple-table", {
              attrs: {
                item: _vm.property,
                "i18-path": "properties_360.fields",
                "table-keys": [
                  "mnt_responsible_technician",
                  "mnt_responsible_phone",
                  "mnt_resp_buddy",
                  "mnt_resp_buddy_phone"
                ]
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage("requests.details.titles.requests")
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("custom-simple-table", {
              attrs: {
                item: _vm.property.maintenance,
                "i18-path": "properties_360.fields.maintenance",
                "table-keys": ["tech_in_charge", "tech_in_charge_phone"]
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }